import UserBookingDetailPage from '@/pages/booking/UserBookingDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/booking/$bookingId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { bookingId } = Route.useParams();
  return <UserBookingDetailPage bookingId={bookingId} />;
}
